import { createFileRoute } from '@tanstack/react-router';
import { Articles } from '@/features/content/Articles';

export const Route = createFileRoute('/_app/articles')({ component: Articles });
